import React, { useMemo, useState } from 'react';
import './css/index.scss';
import { useDispatch } from 'react-redux';
import MyModal from '../../../../components/MyModal';
import { ORGANIZATION_MODAL_STATES } from '../../constants';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';
import { removeOrganization, updateOrganization } from '../../../../store/actions/organizations';
import SearchInput from '../../../../components/SearchInput';
import useInputState from '../../../../helpers/hooks/useInputState';

function OrganizationModal({
  isVisible, setIsVisible, modalState,

  selectedOrganization = {}, setSelectedOrganization,

  selectedOrganizations, setSelectedOrganizations, getOrganizations,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [newUserId, setNewUserId, newUserIdError, setNewUserIdError] = useInputState('');

  const modalTextPart = useMemo(() => {
    if (selectedOrganizations?.length) return `выбранные организации (${selectedOrganizations.length})`;
    return 'эту организацию';
  }, [selectedOrganizations]);

  const closeModal = () => {
    if (loading) {
      return;
    }
    setIsVisible(false);
    setTimeout(() => {
      setSelectedOrganization({});
      setNewUserId('', true);
    }, 400);
  };

  const afterRequestIfManyOrgs = () => {
    setSelectedOrganizations([]);
    getOrganizations();
    closeModal();
  };

  const onActiveChange = (newActiveVal) => async () => {
    const payload = {
      organization_id: selectedOrganization._id,
      organization_ids: selectedOrganizations || [],
      is_active: newActiveVal,
    };

    const data = await sendRequest({
      request: Api.blockOrganization,
      payload,
      warnErrorText: 'while blocking organization',
      setLoading,
    });

    if (data?.status === 'ok') {
      if (selectedOrganizations?.length) {
        return afterRequestIfManyOrgs();
      }
      dispatch(updateOrganization({ ...selectedOrganization, is_active: newActiveVal }));
      closeModal();
    }
  };

  const onDeleteClick = async () => {
    const data = await sendRequest({
      request: Api.deleteOrganization,
      payload: {
        organization_id: selectedOrganization._id,
        organization_ids: selectedOrganizations || [],
      },
      warnErrorText: 'while deleting organization',
      setLoading,
    });

    if (data?.status === 'ok') {
      if (selectedOrganizations?.length) {
        return afterRequestIfManyOrgs();
      }
      dispatch(removeOrganization({ ...selectedOrganization }));
      closeModal();
    }
  };

  const onChangeClick = async () => {
    const payload = {
      organization_id: selectedOrganization._id,
      organization_ids: selectedOrganizations || [],
      new_user_id: newUserId,
    };

    const data = await sendRequest({
      request: Api.changeOrganizationOwner,
      payload,
      warnErrorText: 'while changing organization owner',
      setLoading,
    });

    if (data?.status === 'ok') {
      if (selectedOrganizations?.length) {
        return afterRequestIfManyOrgs();
      }
      dispatch(updateOrganization({ ...selectedOrganization, user: data.organizations?.[0]?.user }));
      closeModal();
    } else if (data?.message === 'This user is banned') {
      setNewUserIdError('Этот пользователь забанен');
    } else if (data?.message === 'This user is not confirmed') {
      setNewUserIdError('Этот пользователь не подтверждён');
    } else {
      setNewUserIdError('Такого пользователя не существует');
    }
  };

  return (
    <MyModal isOpen={isVisible} closeFunction={closeModal}>
      <div className="organization_modal">
        {modalState === ORGANIZATION_MODAL_STATES.block ? (
          <>
            <p className="modal_title">Забанить?</p>
            <p className="modal_info_name">{selectedOrganization.name}</p>
            <p className="modal_info">
              Вы уверены что хотите отправить
              {` ${modalTextPart} `}
              в бан-лист?
            </p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Забанить"
                loading={loading}
                onClick={onActiveChange(false)}
              />
            </div>
          </>
        ) : modalState === ORGANIZATION_MODAL_STATES.fullyDelete ? (
          <>
            <p className="modal_title">Удалить?</p>
            <p className="modal_info_name">{selectedOrganization.name}</p>
            <p className="modal_info">
              Вы уверены что хотите удалить
              {` ${modalTextPart}`}
              ?
            </p>
            <p className="modal_info">Отменить данное действие будет невозможно</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Удалить"
                loading={loading}
                onClick={onDeleteClick}
              />
            </div>
          </>
        ) : modalState === ORGANIZATION_MODAL_STATES.makeActive ? (
          <>
            <p className="modal_title">Разбанить?</p>
            <p className="modal_info_name">{selectedOrganization.name}</p>
            <p className="modal_info">
              Вы уверены что хотите снять
              {` ${modalTextPart} `}
              из бан-листа?
            </p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Разбанить"
                loading={loading}
                onClick={onActiveChange(true)}
              />
            </div>
          </>
        ) : modalState === ORGANIZATION_MODAL_STATES.changeOwner ? (
          <>
            <p className="modal_title">Изменить владельца?</p>

            <div className="modal_simple_block">
              <p className="modal_simple_block_title">{selectedOrganizations?.length ? 'Выбранные организации' : selectedOrganization.name}</p>
              <p className="modal_simple_block_descr">{selectedOrganizations?.length ? selectedOrganizations?.length : 'Название организации'}</p>
            </div>
            <div className="modal_simple_block">
              <p className="modal_simple_block_title">{selectedOrganization.user?._id}</p>
              <p className="modal_simple_block_descr">ID владельца</p>
            </div>

            <SearchInput
              wrapperClassName="modal_input"
              value={newUserId}
              onChange={setNewUserId}
              error={newUserIdError}
              placeholder="Введите ID нового владельца"
              withLeftIcon={false}
            />

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Изменить"
                loading={loading}
                onClick={onChangeClick}
              />
            </div>
          </>
        ) : modalState === ORGANIZATION_MODAL_STATES.changeData ? (
          <>myau</>
        )
          : null}

      </div>
    </MyModal>
  );
}

export default OrganizationModal;
